__turbopack_context__.v({
  "cell": "b8CgtG_cell",
  "cell-in": "b8CgtG_cell-in",
  "contain": "b8CgtG_contain",
  "corner": "b8CgtG_corner",
  "frame": "b8CgtG_frame",
  "layer": "b8CgtG_layer",
  "layer-in": "b8CgtG_layer-in",
  "layout1": "b8CgtG_layout1",
  "layout2": "b8CgtG_layout2",
  "layout3": "b8CgtG_layout3",
  "layout4": "b8CgtG_layout4",
  "layoutMixedLeft": "b8CgtG_layoutMixedLeft",
  "layoutMixedRight": "b8CgtG_layoutMixedRight",
  "photo": "b8CgtG_photo",
  "qr": "b8CgtG_qr",
  "settle": "b8CgtG_settle",
  "waiting": "b8CgtG_waiting",
  "waitingCover": "b8CgtG_waitingCover",
  "waitingPanel": "b8CgtG_waitingPanel",
  "waitingShade": "b8CgtG_waitingShade",
  "wall": "b8CgtG_wall",
  "wipe": "b8CgtG_wipe",
  "wipe-down": "b8CgtG_wipe-down",
  "wipe-up": "b8CgtG_wipe-up",
});
